import * as actionTypes from "../actionTypes/Index";
import { deliveryDateInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...deliveryDateInitialState };

export default function deliveryDateReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_DELIVERY_DATE_WAREHOUSE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isWarehouseCategoriesFetched: false,
        warehouseCategories: [],
      });
    }
    case actionTypes.GET_DELIVERY_DATE_WAREHOUSE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isWarehouseCategoriesFetched: true,
        warehouseCategories: (action.payload! as Array<any>).slice(),
      });
    }
    case actionTypes.GET_DELIVERY_DATE_WAREHOUSE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isWarehouseCategoriesFetched: false,
        warehouseCategories: null,
      });
    }
    case actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        isWarehouseCategoriesFetched: false,
        warehouseDeliveryDateConfig: null,
      });
    }
    case actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isWarehouseCategoriesFetched: true,
        warehouseDeliveryDateConfig: action.payload,
      });
    }
    case actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isWarehouseCategoriesFetched: false,
        warehouseDeliveryDateConfig: null,
      });
    }
    case actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: null,
        warehouseDeliveryDateConfig: null,
        isWarehouseConfigAdded: false,
      });
    }
    case actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        warehouseDeliveryDateConfig: action.payload,
        isWarehouseConfigAdded: true,
      });
    }
    case actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isWarehouseConfigAdded: false,
        warehouseDeliveryDateConfig: null,
      });
    }
    default:
      return state;
  }
}
